import { useCallback, useEffect, useState } from "react";

export function useFullscreen() {
	const [native, setNative] = useState(false);
	const [fallback, setFallback] = useState(false);

	useEffect(() => {
		function onChange() {
			setNative(!!document.fullscreenElement);
		}
		document.addEventListener("fullscreenchange", onChange);
		return () => document.removeEventListener("fullscreenchange", onChange);
	}, []);

	useEffect(() => {
		if (!fallback) return;
		function onKeyDown(event: KeyboardEvent) {
			if (event.key === "Escape" && !event.defaultPrevented) {
				setFallback(false);
			}
		}
		window.addEventListener("keydown", onKeyDown);
		return () => window.removeEventListener("keydown", onKeyDown);
	}, [fallback]);

	const enter = useCallback(async () => {
		const root = document.documentElement;
		if (typeof root.requestFullscreen === "function") {
			try {
				await root.requestFullscreen();
				return;
			} catch {}
		}
		setFallback(true);
	}, []);

	const exit = useCallback(async () => {
		if (document.fullscreenElement) {
			try {
				await document.exitFullscreen();
			} catch {}
		}
		setFallback(false);
	}, []);

	return { active: native || fallback, fallback, enter, exit };
}
